import { readonly } from 'vue'

/**
 * Composable to manage custom hreflang state
 *
 * This composable allows components to signal when they're providing
 * custom hreflang tags from a backend API or other source, preventing
 * duplicate hreflang generation from the global i18n configuration.
 */

export const useCustomHreflangs = () => {
  const hasCustomHreflangs = useState<boolean>(
    'custom-hreflangs-enabled',
    () => false,
  )

  const enableCustomHreflangs = () => {
    hasCustomHreflangs.value = true
  }

  const disableCustomHreflangs = () => {
    hasCustomHreflangs.value = false
  }

  return {
    hasCustomHreflangs: readonly(hasCustomHreflangs),
    enableCustomHreflangs,
    disableCustomHreflangs,
  }
}
